import axios from "axios";
import React, { useEffect, useState } from "react";
import InputField from "../../InputField";
import Footer from "../Include/Footer";
import Header from "../Include/Header";
import { useFormik } from "formik";
import { submitUserSchema } from "../../schema";
import { toast } from "react-toastify";
import "./FileClaim.css";
import secureLocalStorage from "react-secure-storage";
import UserService from "../../../services/user.service";
import { useSelector } from "react-redux";
import ProductService from "../../../services/product.service";
import { Helmet } from "react-helmet";
import Select from "react-select";

import StoreService from "../../../services/store.service";

function FileClaims() {
  const TITLE = "BIA Sleep RSA Spiffs | File A Claims";

  const initialInputTypes = [
    { id: 1, type: "text" },
    { id: 2, type: "text" },
    { id: 3, type: "text" },
  ];
  const [inputTypes, setInputTypes] = useState(initialInputTypes);

  const handleInputClick = (id) => {
    const updatedInputTypes = inputTypes.map((input) => {
      if (input.id === id) {
        return { ...input, type: "date" };
      }
      return input;
    });
    setInputTypes(updatedInputTypes);
  };

  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [image2, setImage2] = useState(null);
  const [image3, setImage3] = useState(null);

  const [prod, setProd] = useState("");
  const [prod2, setProd2] = useState("");
  const [prod3, setProd3] = useState("");

  const [selSize, setSelSize] = useState("");
  const [selSize2, setSelSize2] = useState("");
  const [selSize3, setSelSize3] = useState("");

  const [price, setPrice] = useState("");
  const [price2, setPrice2] = useState("");
  const [price3, setPrice3] = useState("");

  const [product, setProduct] = useState([]);

  const [size, setSize] = useState([]);
  const [size2, setSize2] = useState([]);
  const [size3, setSize3] = useState([]);

  const [split, setSplit] = useState("0");
  const [split2, setSplit2] = useState("0");
  const [split3, setSplit3] = useState("0");

  const [quantity, setQuantity] = useState(1);
  const [quantity2, setQuantity2] = useState(1);
  const [quantity3, setQuantity3] = useState(1);

  const [claimPriceLoader, setClaimPriceLoader] = useState(false);
  const [claimPriceLoader2, setClaimPriceLoader2] = useState(false);
  const [claimPriceLoader3, setClaimPriceLoader3] = useState(false);

  const [sizeLoader, setSizeLoader] = useState(false);
  const [sizeLoader2, setSizeLoader2] = useState(false);
  const [sizeLoader3, setSizeLoader3] = useState(false);

  const state = useSelector((state) => state.stateVals);
  const { id } = state;

  const onFileChange = (e) => {
    setImage(e);
  };

  const onFileChange2 = (e) => {
    setImage2(e);
  };

  const onFileChange3 = (e) => {
    setImage3(e);
  };
  const [selectedOption, setSelectedOption] = useState(null);
  useEffect(() => {
    setProduct([]);

    const getRetailerInfo = async () => {
      try {
        const response = await StoreService.getRetailerInfoById(id);

        setSelectedOption(response?.data?.response);
        setFieldValue("retailer", response?.data?.response?.value);
        getProduct(response?.data?.response?.value);
      } catch (error) {
        setSelectedOption(null);
      }
    };

    getRetailerInfo();
  }, []);

  const getProduct = async (id) => {
    setFieldValue("product", "");
    setFieldValue("size", "");
    setFieldValue("product2", "");
    setFieldValue("size2", "");
    setFieldValue("product3", "");
    setFieldValue("size3", "");

    setPrice("");
    setSelSize("");
    setProd("");
    setSize([]);

    setPrice2("");
    setSelSize2("");
    setProd2("");
    setSize2([]);

    setPrice3("");
    setSelSize3("");
    setProd3("");
    setSize3([]);
    const { data } = await ProductService.getProduct(id);

    const { response: res } = data;
    const results = [];
    res.map((value) => {
      results.push({
        key: value.name,
        value: value.id,
      });
    });
    setProduct([...results]);
  };

  const changeQuantity = (e) => {
    if (e == "") {
      e = "1";
    }

    setQuantity(e);
    setPrice("");
    const getPrice = async () => {
      try {
        setClaimPriceLoader(true);
        const { data } = await UserService.getProdPrice(id, prod, selSize);
        const { response } = data;
        setPrice(response * e);
        if (split == true) {
          setPrice((response * e) / 2);
        }
        setClaimPriceLoader(false);
      } catch (error) {
        setClaimPriceLoader(false);
        setPrice(0);
      }
    };

    if (e != "" && prod != "") {
      getPrice();
    }
  };

  const changeQuantity2 = (e) => {
    if (e == "") {
      e = "1";
    }
    setQuantity2(e);
    setPrice2("");
    const getPrice = async () => {
      try {
        setClaimPriceLoader2(true);
        const { data } = await UserService.getProdPrice(id, prod2, selSize2);
        const { response } = data;
        setPrice2(response * e);
        if (split2 == true) {
          setPrice2((response * e) / 2);
        }
        setClaimPriceLoader2(false);
      } catch (error) {
        setClaimPriceLoader2(false);
        setPrice2(0);
      }
    };

    if (prod2 != "" && e != "") {
      getPrice();
    }
  };

  const changeQuantity3 = (e) => {
    if (e == "") {
      e = "1";
    }
    setQuantity3(e);
    setPrice3("");
    const getPrice = async () => {
      try {
        setClaimPriceLoader3(true);
        const { data } = await UserService.getProdPrice(id, prod3, selSize3);
        const { response } = data;
        setPrice3(response * e);
        if (split3 == true) {
          setPrice3((response * e) / 2);
        }
        setClaimPriceLoader3(false);
      } catch (error) {
        setClaimPriceLoader3(false);
        setPrice3(0);
      }
    };

    if (prod3 != "" && e != "") {
      getPrice();
    }
  };

  const fetchPrice = (e) => {
    setSelSize(e);
    setPrice("");
    const getPrice = async () => {
      try {
        setClaimPriceLoader(true);
        const { data } = await UserService.getProdPrice(id, prod, e);
        const { response } = data;
        setPrice(response * quantity);
        if (split == true) {
          setPrice((response * quantity) / 2);
        }
        setClaimPriceLoader(false);
      } catch (error) {
        setClaimPriceLoader(false);
        setPrice(0);
      }
    };

    if (e != "") {
      getPrice();
    }
  };

  const fetchPrice2 = (e) => {
    setSelSize2(e);
    setPrice2("");
    const getPrice = async () => {
      try {
        setClaimPriceLoader2(true);
        const { data } = await UserService.getProdPrice(id, prod2, e);
        const { response } = data;
        setPrice2(response * quantity2);
        if (split2 == true) {
          setPrice2((response * quantity2) / 2);
        }
        setClaimPriceLoader2(false);
      } catch (error) {
        setClaimPriceLoader2(false);
        setPrice2(0);
      }
    };

    if (e != "") {
      getPrice();
    }
  };

  const fetchPrice3 = (e) => {
    console.log("price 3");
    setSelSize3(e);
    setPrice3("");

    const getPrice = async () => {
      try {
        setClaimPriceLoader3(true);
        const { data } = await UserService.getProdPrice(id, prod3, e);
        const { response } = data;

        setPrice3(response * quantity3);
        if (split3 == true) {
          setPrice3((response * quantity3) / 2);
        }
        setClaimPriceLoader3(false);
      } catch (error) {
        setClaimPriceLoader3(false);
        setPrice3(0);
      }
    };

    if (e != "") {
      getPrice();
    }
  };

  const changeSplit = (e) => {
    setPrice("");
    setSplit(e);
    const getPrice = async () => {
      try {
        setClaimPriceLoader(true);
        const { data } = await UserService.getProdPrice(id, prod, selSize);
        const { response } = data;
        setPrice(response * quantity);
        if (e === true) {
          setPrice((response * quantity) / 2);
        }
        setClaimPriceLoader(false);
      } catch (error) {
        setPrice(0);
        setClaimPriceLoader(false);
      }
    };

    if (prod != "" && selSize != "") {
      getPrice();
    }
  };

  const changeSplit2 = (e) => {
    setPrice2("");
    setSplit2(e);
    const getPrice = async () => {
      try {
        setClaimPriceLoader2(true);
        const { data } = await UserService.getProdPrice(id, prod2, selSize2);
        const { response } = data;
        setPrice2(response * quantity2);
        if (e === true) {
          setPrice2((response * quantity2) / 2);
        }
        setClaimPriceLoader2(false);
      } catch (error) {
        setPrice2(0);

        setClaimPriceLoader2(false);
      }
    };

    if (prod2 != "" && selSize2 != "") {
      getPrice();
    }
  };

  const changeSplit3 = (e) => {
    setPrice3("");
    setSplit3(e);
    const getPrice = async () => {
      try {
        setClaimPriceLoader3(true);
        const { data } = await UserService.getProdPrice(id, prod3, selSize3);
        const { response } = data;
        setPrice3(response * quantity3);
        if (e === true) {
          setPrice3((response * quantity3) / 2);
        }
        setClaimPriceLoader3(false);
      } catch (error) {
        setPrice3(0);
        setClaimPriceLoader3(false);
      }
    };

    if (prod3 != "" && selSize3 != "") {
      getPrice();
    }
  };

  const changeSize = (e) => {
    setPrice("");
    setProd(e);
    setSize([]);
    values.size = "";

    const getSize = async () => {
      setSizeLoader(true);
      try {
        const { data } = await ProductService.getSizeByUserProduct(
          values.retailer,
          e,
        );
        const { response: res } = data;
        const results = [];
        res.map((value) => {
          results.push({
            key: value.size,

            price: value.price,
            value: value.id,
          });
        });
        setSize([...results]);
        setSizeLoader(false);
      } catch (error) {
        setSize([]);
        setSizeLoader(false);
      }
    };

    if (e !== "") {
      setProd(e);
      getSize();
    }
  };

  const changeSize2 = (e) => {
    setPrice2("");
    setProd2(e);
    setSize2([]);
    values.size2 = "";

    const getSize = async () => {
      setSizeLoader2(true);
      try {
        const { data } = await ProductService.getSizeByUserProduct(id, e);
        const { response: res } = data;
        const results = [];
        res.map((value) => {
          results.push({
            key: value.size,

            price: value.price,
            value: value.id,
          });
        });
        setSize2([...results]);
        setSizeLoader2(false);
      } catch (error) {
        setSize2([]);
        setSizeLoader2(false);
      }
    };

    if (e !== "") {
      setProd2(e);
      getSize();
    }
  };

  const changeSize3 = (e) => {
    setPrice3("");
    setProd3(e);
    setSize3([]);
    values.size3 = "";

    const getSize = async () => {
      setSizeLoader3(true);
      try {
        const { data } = await ProductService.getSizeByUserProduct(id, e);
        const { response: res } = data;
        const results = [];
        res.map((value) => {
          results.push({
            key: value.size,

            price: value.price,
            value: value.id,
          });
        });
        setSize3([...results]);
        setSizeLoader3(false);
      } catch (error) {
        setSize3([]);
        setSizeLoader3(false);
      }
    };

    if (e !== "") {
      setProd3(e);
      getSize();
    }
  };

  // }, [userActions, accessToken, navigate]);

  const resetPrices = () => {
    setPrice("");
    setPrice2("");
    setPrice3("");
  };

  const SubmitClaim = async (action, values, rId) => {
    try {
      setLoading(true);
      const response = await UserService.SubmitClaim(values, id, rId);
      const { data: res } = response;
      setLoading(false);

      toast.success(res.response, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      action.resetForm();
      resetPrices();
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (err) {
      setLoading(false);

      if (
        err?.response?.data?.response &&
        typeof err?.response?.data?.response === "string"
      ) {
        toast.error(err?.response?.data?.response, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (
        err?.response?.data?.error &&
        typeof err?.response?.data?.error === "string"
      ) {
        toast.error(err?.response?.data?.error, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        toast.error("Something went wrong", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  const {
    values,
    errors,
    touched,
    setFieldTouched,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    enableReinitialize: true,

    initialValues: {
      retailer: "",
      product: "",
      product2: "",
      product3: "",

      size: "",
      size2: "",
      size3: "",

      invoice: "",
      invoice2: "",
      invoice3: "",

      invoice_date: "",
      invoice_date2: "",
      invoice_date3: "",

      quantity: "",
      quantity2: "",
      quantity3: "",

      image: "",
      image2: "",
      image3: "",

      split1: " ",
      split2: " ",
      split3: " ",
    },
    validationSchema: submitUserSchema,

    onSubmit: (values, action) => {
      var bodyFormData = new FormData();
      // FORM 1
      const splitStatus = values.split1 == "on" ? "1" : "0";
      bodyFormData.append("split_status", splitStatus);
      bodyFormData.append("product", values.product);
      bodyFormData.append("size", values.size);
      bodyFormData.append("invoice", values.invoice);
      bodyFormData.append("invoice_date", values.invoice_date);
      bodyFormData.append("quantity", values.quantity);
      bodyFormData.append("image", image, image.name);

      if (values.product2 != "") {
        // FORM 2
        const splitStatus2 = values.split2.includes("on") ? "1" : "0";
        bodyFormData.append("split_status2", splitStatus2);
        bodyFormData.append("product2", values.product2);
        bodyFormData.append("size2", values.size2);
        bodyFormData.append("invoice2", values.invoice2);
        bodyFormData.append("invoice_date2", values.invoice_date2);
        bodyFormData.append("quantity2", values.quantity2);
        bodyFormData.append("image2", image2, image2.name);
      }

      if (values.product3 != "") {
        // FORM 3
        const splitStatus3 = values.split3.includes("on") ? "1" : "0";
        bodyFormData.append("split_status3", splitStatus3);
        bodyFormData.append("product3", values.product3);
        bodyFormData.append("size3", values.size3);
        bodyFormData.append("invoice3", values.invoice3);
        bodyFormData.append("invoice_date3", values.invoice_date3);
        bodyFormData.append("quantity3", values.quantity3);
        bodyFormData.append("image3", image3, image3.name);
      }

      bodyFormData.append("ip", secureLocalStorage.getItem("ip"));

      SubmitClaim(action, bodyFormData, values.retailer);
      // action.resetForm();
    },
  });

  // const splitValue = (e) => {
  //   console.log("value=" + e);
  //   let value = "";
  //   if (e === "on") {
  //     value = "1";
  //   } else {
  //     value = "0";
  //   }
  //   return value;
  // };

  useEffect(() => {
    const getIp = async () => {
      const res = await axios.get("https://api.ipify.org?format=json");

      const weIp = res.data.ip;
      secureLocalStorage.setItem("ip", weIp);
    };
    getIp();
  }, [handleSubmit]);

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="user-panel">
        <section className="main-ban page-heading">
          <div className="container">
            <Header />
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* <div className="traning-awards">
                  <h1 className="mban-head w-100">HOPE TO DREAM SALES</h1>
                </div> */}
                <h2 className="gen-hed">
                  FILE A <span className="slide-heading">CLAIM</span>
                </h2>
              </div>
            </div>
          </div>
        </section>

        <section className="claims-part">
          <div className="container">
            <div className="row">
              <div className="Whitebg-box" id="FileClaimsBox">
                <form onSubmit={handleSubmit} noValidate>
                  <ul className="timeline claim_detail">
                    <li>
                      <div className="prfil-set overflow-visible">
                        <div className="form-box">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="alert alert-danger" role="alert">
                                <h6 className="astric-req">
                                  Field(s) marked with <span>Asterisk (*)</span>{" "}
                                  are mandatory.
                                </h6>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <h4 className="prf-hed">RETAILER INFORMATION</h4>
                            </div>
                          </div>

                          <div className="form-filds ">
                            <div className="row">
                              {/* <div className="col-lg-6">
                                <div
                                  className={`form-floating ${
                                    errors.retailer && touched.retailer
                                      ? "is-danger"
                                      : ""
                                  }`}
                                >
                                  <Select
                                    value={selectedOption}
                                    className={
                                      errors.retailer && touched.retailer
                                        ? "error-select-search"
                                        : ""
                                    }
                                    placeholder={"SELECT RETAILER"}
                                    // placeholder={"* SELECT STATE/PROVINCE"}
                                    options={retailer}
                                    isSearchable={true}
                                    name="retailer"
                                    onChange={(selectedOption) => {
                                      handleSelectChange(selectedOption);
                                      if (selectedOption) {
                                        setFieldValue(
                                          "retailer",
                                          selectedOption.value
                                        );
                                        getProduct(selectedOption.value);
                                      } else {
                                        setFieldValue("retailer", "");
                                      }
                                    }}
                                    onBlur={() =>
                                      setFieldTouched("retailer", true)
                                    }
                                  />
                                  <label
                                    htmlFor="floatingSelect"
                                    className="with-select"
                                  >
                                    <span>*</span> RETAILER
                                  </label>
                                  {errors.retailer && touched.retailer ? (
                                    <p className="help is-danger">
                                      {errors.retailer}
                                    </p>
                                  ) : null}
                                </div>
                              </div> */}
                              <div className="col-md-4" id="image-container">
                                <ul className="cards">
                                  <li>
                                    <div className="card">
                                      <img
                                        src={`${process.env.REACT_APP_IMAGE_Link}/${selectedOption?.image}`}
                                        className="card__image"
                                        alt=""
                                      />
                                      <div className="card__overlay">
                                        <div className="card__header">
                                          <svg
                                            className="card__arc"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path></path>
                                          </svg>
                                          <div className="card__header-text">
                                            <span className="card__status">
                                              Retailer Name
                                            </span>

                                            <h3 className="card__title">
                                              {selectedOption?.label}
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="prfil-set">
                        <div className="form-box">
                          <div className="row">
                            <div className="col-12">
                              <div className="alert alert-info" role="alert">
                                <h6 className="astric-req">
                                  First box of{" "}
                                  <strong>PRODUCT INFORMATION</strong> is
                                  mandatory rest of them will be saved only when
                                  they are filled completely.
                                </h6>
                              </div>
                            </div>
                          </div>

                          {/* <div className="row">
                            <div className="col-12">
                              <div className="chek-term">
                                <input
                                  id="radio-1"
                                  className="radio-custom"
                                  name="split1"
                                  onChange={(e) => {
                                    handleChange(e);
                                    changeSplit(e.target.checked);
                                  }}
                                  onBlur={handleBlur}
                                  type="checkbox"
                                />
                                <label
                                  htmlFor="radio-1"
                                  className={`radio-custom-label ${
                                    errors.split1 && touched.split1
                                      ? "is-danger"
                                      : ""
                                  }`}
                                >
                                  SPLIT SALE
                                </label>

                                {errors.split1 && touched.split1 ? (
                                  <p className="help is-danger">
                                    {errors.split1}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <br /> */}
                          <div className="row ">
                            <div className="col-6">
                              <h4 className="prf-hed">
                                PRODUCT INFORMATION
                              </h4>{" "}
                            </div>

                            {price !== "" ? (
                              <div className="col-6">
                                <div className="claimPrice">
                                  Reward: ${price}
                                </div>{" "}
                              </div>
                            ) : (
                              ""
                            )}

                            {claimPriceLoader && (
                              <div className="col-6">
                                <div className="claimPrice">
                                  <span
                                    className="spinner-border spinner-border-smSplit1"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="form-filds">
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="select-leading">
                                  {/* {userCityLoader ? (
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  ) : null} */}
                                  <div
                                    className={`form-floating ${
                                      errors.product && touched.product
                                        ? "is-danger"
                                        : ""
                                    }`}
                                  >
                                    <select
                                      className="form-select"
                                      onChange={(e) => {
                                        changeSize(e.target.value);
                                        handleChange(e);
                                      }}
                                      onBlur={handleBlur}
                                      name="product"
                                      value={values.product || ""}
                                      required
                                    >
                                      <option value="">SELECT PRODUCT</option>
                                      {product.map((res) => {
                                        return (
                                          <option
                                            key={res.key}
                                            value={res.value}
                                          >
                                            {res.key}
                                          </option>
                                        );
                                      })}
                                    </select>
                                    <label>
                                      <span>*</span> PRODUCT SOLD
                                    </label>
                                    {errors.product && touched.product ? (
                                      <p className="help is-danger">
                                        {errors.product}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="select-leading">
                                  {sizeLoader ? (
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  ) : null}
                                  <div
                                    className={`form-floating ${
                                      errors.size && touched.size
                                        ? "is-danger"
                                        : ""
                                    }`}
                                  >
                                    <select
                                      className="form-select"
                                      onChange={(e) => {
                                        handleChange(e);
                                        fetchPrice(e.target.value);
                                      }}
                                      onBlur={handleBlur}
                                      name="size"
                                      value={values.size || ""}
                                      required
                                    >
                                      <option value="">
                                        SELECT Size/Spiff
                                      </option>
                                      {size.map((res) => {
                                        return (
                                          <option
                                            key={res.value}
                                            value={res.value}
                                          >
                                            {`${res.key}/ $${res.price}`}
                                          </option>
                                        );
                                      })}
                                    </select>
                                    <label>
                                      <span>*</span> Size/Spiff
                                    </label>
                                    {errors.size && touched.size ? (
                                      <p className="help is-danger">
                                        {errors.size}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <InputField
                                  errors={errors.invoice}
                                  touched={touched.invoice}
                                  values={values.invoice}
                                  handleChange={handleChange}
                                  handleBlur={handleBlur}
                                  placeholder="DELIVERED INVOICE No."
                                  spanText="DELIVERED INVOICE NO."
                                  fieldName="invoice"
                                  fieldType="text"
                                  required={true}
                                />
                              </div>

                              <div className="col-lg-6">
                                <div
                                  className={`form-floating ${
                                    errors.invoice_date && touched.invoice_date
                                      ? "is-danger"
                                      : ""
                                  }`}
                                >
                                  <input
                                    id={inputTypes[0].id}
                                    type={inputTypes[0].type}
                                    // onClick={() => handleInputClick(inputTypes[0].id)}
                                    onFocus={() =>
                                      handleInputClick(inputTypes[0].id)
                                    }
                                    placeholder=" "
                                    className="form-control"
                                    onChange={handleChange}
                                    onKeyUp={(e) => e.preventDefault()}
                                    onKeyDown={(e) => e.preventDefault()}
                                    onBlur={handleBlur}
                                    name="invoice_date"
                                    value={values.invoice_date || ""}
                                    required
                                  />
                                  <label className="date">
                                    <span>*</span> INVOICE DATE
                                  </label>
                                  {errors.invoice_date &&
                                  touched.invoice_date ? (
                                    <p className="help is-danger">
                                      {errors.invoice_date}
                                    </p>
                                  ) : null}
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="select-leading">
                                  <div
                                    className={`form-floating ${
                                      errors.quantity && touched.quantity
                                        ? "is-danger"
                                        : ""
                                    }`}
                                  >
                                    <select
                                      className="form-select"
                                      onChange={(e) => {
                                        handleChange(e);
                                        changeQuantity(e.target.value);
                                      }}
                                      onBlur={handleBlur}
                                      name="quantity"
                                      value={values.quantity || ""}
                                      required
                                    >
                                      <option value="">SELECT QUANTITY</option>
                                      <option value="1">1</option>
                                      <option value="2">2</option>
                                      <option value="3">3</option>
                                      <option value="4">4</option>
                                      <option value="5">5</option>
                                      <option value="6">6</option>
                                      <option value="7">7</option>
                                      <option value="8">8</option>
                                    </select>
                                    <label>
                                      <span>*</span> QUANTITY SHIPPED
                                    </label>
                                    {errors.quantity && touched.quantity ? (
                                      <p className="help is-danger">
                                        {errors.quantity}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <InputField
                                  className="file"
                                  errors={errors.image}
                                  touched={touched.image}
                                  values={values.image}
                                  handleChange={(e) => {
                                    handleChange(e);
                                    onFileChange(e.target.files[0]);
                                  }}
                                  handleBlur={handleBlur}
                                  placeholder="UPLOAD FILE"
                                  spanText="UPLOAD FILE"
                                  fieldName="image"
                                  fieldType="file"
                                  required={true}
                                />
                              </div>
                              <div className="col-md-12">
                                <p>
                                  {" "}
                                  You can upload only <b>
                                    jpg, jpeg, png, gif
                                  </b>{" "}
                                  and <b>pdf</b> files. Maximum size allowed is{" "}
                                  <b>10MB.</b>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="prfil-set">
                        <div className="form-box">
                          {/* <div className="row">
                            <div className="col-12">
                              <div className="chek-term">
                                <input
                                  id="radio-2"
                                  className="radio-custom"
                                  name="split2"
                                  onChange={(e) => {
                                    handleChange(e);
                                    changeSplit2(e.target.checked);
                                  }}
                                  onBlur={handleBlur}
                                  type="checkbox"
                                />
                                <label
                                  htmlFor="radio-2"
                                  className={`radio-custom-label ${
                                    errors.split2 && touched.split2
                                      ? "is-danger"
                                      : ""
                                  }`}
                                >
                                  SPLIT SALE
                                </label>

                                {errors.split2 && touched.split2 ? (
                                  <p className="help is-danger">
                                    {errors.split2}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <br /> */}
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="row justify-content-between">
                                <div className="col-6">
                                  <h4 className="prf-hed">
                                    PRODUCT INFORMATION
                                  </h4>{" "}
                                </div>
                                {price2 !== "" ? (
                                  <div className="col-6">
                                    <div className="claimPrice2">
                                      Reward: ${price2}
                                    </div>{" "}
                                  </div>
                                ) : (
                                  ""
                                )}

                                {claimPriceLoader2 && (
                                  <div className="col-6">
                                    <div className="claimPrice2">
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="form-filds">
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="select-leading">
                                  {/* {userCityLoader ? (
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  ) : null} */}
                                  <div
                                    className={`form-floating ${
                                      errors.product2 && touched.product2
                                        ? "is-danger"
                                        : ""
                                    }`}
                                  >
                                    <select
                                      className="form-select"
                                      onChange={(e) => {
                                        changeSize2(e.target.value);
                                        handleChange(e);
                                      }}
                                      onBlur={handleBlur}
                                      name="product2"
                                      value={values.product2 || ""}
                                      required
                                    >
                                      <option value="">SELECT PRODUCT</option>
                                      {product.map((res) => {
                                        return (
                                          <option
                                            key={res.value}
                                            value={res.value}
                                          >
                                            {res.key}
                                          </option>
                                        );
                                      })}
                                    </select>
                                    <label>
                                      <span>*</span> SELECT PRODUCT
                                    </label>
                                    {errors.product2 && touched.product2 ? (
                                      <p className="help is-danger">
                                        {errors.product2}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="select-leading">
                                  {sizeLoader2 ? (
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  ) : null}
                                  <div
                                    className={`form-floating ${
                                      errors.size2 && touched.size2
                                        ? "is-danger"
                                        : ""
                                    }`}
                                  >
                                    <select
                                      className="form-select"
                                      onChange={(e) => {
                                        handleChange(e);
                                        fetchPrice2(e.target.value);
                                      }}
                                      onBlur={handleBlur}
                                      name="size2"
                                      value={values.size2 || ""}
                                      required
                                    >
                                      <option value="">
                                        SELECT Size/Spiff
                                      </option>

                                      {size2.map((res) => {
                                        return (
                                          <option
                                            key={res.value}
                                            value={res.value}
                                          >
                                            {`${res.key}/ $${res.price}`}
                                          </option>
                                        );
                                      })}
                                    </select>
                                    <label>
                                      <span>*</span> Size/Spiff
                                    </label>
                                    {errors.size2 && touched.size2 ? (
                                      <p className="help is-danger">
                                        {errors.size2}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <InputField
                                  errors={errors.invoice2}
                                  touched={touched.invoice2}
                                  values={values.invoice2}
                                  handleChange={handleChange}
                                  handleBlur={handleBlur}
                                  placeholder="DELIVERED INVOICE NO."
                                  spanText="DELIVERED INVOICE NO."
                                  fieldName="invoice2"
                                  fieldType="text"
                                  required={true}
                                />
                              </div>

                              <div className="col-lg-6">
                                <div
                                  className={`form-floating ${
                                    errors.invoice_date2 &&
                                    touched.invoice_date2
                                      ? "is-danger"
                                      : ""
                                  }`}
                                >
                                  <input
                                    id={inputTypes[1].id}
                                    type={inputTypes[1].type}
                                    // onClick={() => handleInputClick(inputTypes[1].id)}
                                    onFocus={() =>
                                      handleInputClick(inputTypes[1].id)
                                    }
                                    placeholder=" "
                                    className="form-control"
                                    onKeyUp={(e) => e.preventDefault()}
                                    onKeyDown={(e) => e.preventDefault()}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="invoice_date2"
                                    value={values.invoice_date2 || ""}
                                    required
                                  />
                                  <label className="date">
                                    <span>*</span> INVOICE DATE
                                  </label>
                                  {errors.invoice_date2 &&
                                  touched.invoice_date2 ? (
                                    <p className="help is-danger">
                                      {errors.invoice_date2}
                                    </p>
                                  ) : null}
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="select-leading">
                                  <div
                                    className={`form-floating ${
                                      errors.quantity2 && touched.quantity2
                                        ? "is-danger"
                                        : ""
                                    }`}
                                  >
                                    <select
                                      className="form-select"
                                      onChange={(e) => {
                                        handleChange(e);
                                        changeQuantity2(e.target.value);
                                      }}
                                      onBlur={handleBlur}
                                      name="quantity2"
                                      value={values.quantity2 || ""}
                                      required
                                    >
                                      <option value="">SELECT QUANTITY</option>
                                      <option value="1">1</option>
                                      <option value="2">2</option>
                                      <option value="3">3</option>
                                      <option value="4">4</option>
                                      <option value="5">5</option>
                                      <option value="6">6</option>
                                      <option value="7">7</option>
                                      <option value="8">8</option>
                                    </select>
                                    <label>
                                      <span>*</span> QUANTITY SHIPPED
                                    </label>
                                    {errors.quantity2 && touched.quantity2 ? (
                                      <p className="help is-danger">
                                        {errors.quantity2}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <InputField
                                  className="file"
                                  errors={errors.image2}
                                  touched={touched.image2}
                                  values={values.image2}
                                  handleChange={(e) => {
                                    handleChange(e);
                                    onFileChange2(e.target.files[0]);
                                  }}
                                  handleBlur={handleBlur}
                                  placeholder="UPLOAD IMAGE"
                                  spanText="UPLOAD IMAGE"
                                  fieldName="image2"
                                  fieldType="file"
                                  required={true}
                                />
                              </div>
                              <div className="col-md-12">
                                <p>
                                  {" "}
                                  You can upload only <b>
                                    jpg, jpeg, png, gif
                                  </b>{" "}
                                  and <b>pdf</b> files. Maximum size allowed is{" "}
                                  <b>10MB.</b>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="prfil-set">
                        <div className="form-box">
                          {/* <div className="row">
                            <div className="col-12">
                              <div className="chek-term">
                                <input
                                  id="radio-3"
                                  className="radio-custom"
                                  name="split3"
                                  onChange={(e) => {
                                    handleChange(e);
                                    changeSplit3(e.target.checked);
                                  }}
                                  onBlur={handleBlur}
                                  type="checkbox"
                                />
                                <label
                                  htmlFor="radio-3"
                                  className={`radio-custom-label ${
                                    errors.split3 && touched.split3
                                      ? "is-danger"
                                      : ""
                                  }`}
                                >
                                  SPLIT SALE
                                </label>

                                {errors.split3 && touched.split3 ? (
                                  <p className="help is-danger">
                                    {errors.split3}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <br /> */}
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="row justify-content-between">
                                <div className="col-6">
                                  <h4 className="prf-hed">
                                    PRODUCT INFORMATION
                                  </h4>{" "}
                                </div>
                                {price3 !== "" ? (
                                  <div className="col-6">
                                    <div className="claimPrice3">
                                      Reward: ${price3}
                                    </div>{" "}
                                  </div>
                                ) : (
                                  ""
                                )}

                                {claimPriceLoader3 && (
                                  <div className="col-6">
                                    <div className="claimPrice3">
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="form-filds">
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="select-leading">
                                  <div
                                    className={`form-floating ${
                                      errors.product3 && touched.product3
                                        ? "is-danger"
                                        : ""
                                    }`}
                                  >
                                    <select
                                      className="form-select"
                                      onChange={(e) => {
                                        changeSize3(e.target.value);
                                        handleChange(e);
                                      }}
                                      onBlur={handleBlur}
                                      name="product3"
                                      value={values.product3 || ""}
                                      required
                                    >
                                      <option value="">SELECT PRODUCT</option>
                                      {product.map((res) => {
                                        return (
                                          <option
                                            key={res.value}
                                            value={res.value}
                                          >
                                            {res.key}
                                          </option>
                                        );
                                      })}
                                    </select>
                                    <label>
                                      <span>*</span> SELECT PRODUCT
                                    </label>
                                    {errors.product3 && touched.product3 ? (
                                      <p className="help is-danger">
                                        {errors.product3}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="select-leading">
                                  {sizeLoader3 ? (
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  ) : null}
                                  <div
                                    className={`form-floating ${
                                      errors.size3 && touched.size3
                                        ? "is-danger"
                                        : ""
                                    }`}
                                  >
                                    <select
                                      className="form-select"
                                      onChange={(e) => {
                                        handleChange(e);
                                        fetchPrice3(e.target.value);
                                      }}
                                      onBlur={handleBlur}
                                      name="size3"
                                      value={values.size3 || ""}
                                      required
                                    >
                                      <option value="">
                                        SELECT Size/Spiff
                                      </option>

                                      {size3.map((res) => {
                                        return (
                                          <option
                                            key={res.value}
                                            value={res.value}
                                          >
                                            {`${res.key}/ $${res.price}`}
                                          </option>
                                        );
                                      })}
                                    </select>
                                    <label>
                                      <span>*</span> Size/Spiff
                                    </label>
                                    {errors.size3 && touched.size3 ? (
                                      <p className="help is-danger">
                                        {errors.size3}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <InputField
                                  errors={errors.invoice3}
                                  touched={touched.invoice3}
                                  values={values.invoice3}
                                  handleChange={handleChange}
                                  handleBlur={handleBlur}
                                  placeholder="DELIVERED INVOICE NO."
                                  spanText="DELIVERED INVOICE NO."
                                  fieldName="invoice3"
                                  fieldType="text"
                                  required={true}
                                />
                              </div>

                              <div className="col-lg-6">
                                <div
                                  className={`form-floating ${
                                    errors.invoice_date3 &&
                                    touched.invoice_date3
                                      ? "is-danger"
                                      : ""
                                  }`}
                                >
                                  <input
                                    id={inputTypes[2].id}
                                    type={inputTypes[2].type}
                                    // onClick={() => handleInputClick(inputTypes[2].id)}
                                    onFocus={() =>
                                      handleInputClick(inputTypes[2].id)
                                    }
                                    className="form-control"
                                    // className="form-input"
                                    onChange={handleChange}
                                    onKeyUp={(e) => e.preventDefault()}
                                    onKeyDown={(e) => e.preventDefault()}
                                    onBlur={handleBlur}
                                    name="invoice_date3"
                                    value={values.invoice_date3 || ""}
                                    required
                                    placeholder=" "
                                  />
                                  <label className="date">
                                    <span>*</span> INVOICE DATE
                                  </label>
                                  {errors.invoice_date3 &&
                                  touched.invoice_date3 ? (
                                    <p className="help is-danger">
                                      {errors.invoice_date3}
                                    </p>
                                  ) : null}
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="select-leading">
                                  <div
                                    className={`form-floating ${
                                      errors.quantity3 && touched.quantity3
                                        ? "is-danger"
                                        : ""
                                    }`}
                                  >
                                    <select
                                      className="form-select"
                                      onChange={(e) => {
                                        handleChange(e);
                                        changeQuantity3(e.target.value);
                                      }}
                                      onBlur={handleBlur}
                                      name="quantity3"
                                      value={values.quantity3 || ""}
                                      required
                                    >
                                      <option value="">SELECT QUANTITY</option>
                                      <option value="1">1</option>
                                      <option value="2">2</option>
                                      <option value="3">3</option>
                                      <option value="4">4</option>
                                      <option value="5">5</option>
                                      <option value="6">6</option>
                                      <option value="7">7</option>
                                      <option value="8">8</option>
                                    </select>
                                    <label>
                                      <span>*</span> QUANTITY SHIPPED
                                    </label>
                                    {errors.quantity3 && touched.quantity3 ? (
                                      <p className="help is-danger">
                                        {errors.quantity3}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <InputField
                                  className="file"
                                  errors={errors.image3}
                                  touched={touched.image3}
                                  values={values.image3}
                                  handleChange={(e) => {
                                    handleChange(e);
                                    onFileChange3(e.target.files[0]);
                                  }}
                                  handleBlur={handleBlur}
                                  placeholder="UPLOAD IMAGE"
                                  spanText="UPLOAD IMAGE"
                                  fieldName="image3"
                                  fieldType="file"
                                  required={true}
                                />
                              </div>
                              <div className="col-md-12">
                                <p>
                                  {" "}
                                  You can upload only <b>
                                    jpg, jpeg, png, gif
                                  </b>{" "}
                                  and <b>pdf</b> files. Maximum size allowed is{" "}
                                  <b>10MB.</b>
                                </p>
                              </div>

                              <div className="col-lg-6">
                                <button
                                  type="submit"
                                  className="round-red-btn w-100 mt-3 "
                                  value="SUBMIT"
                                >
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  SUBMIT
                                </button>
                              </div>
                              <div className="col-lg-6">
                                <input
                                  type="reset"
                                  className="round-red-btn w-100 mt-3 reset-reg"
                                  value="RESET FORM"
                                  onClick={() => window.location.reload(false)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  {/* <div className="container">
                    <div className="row">
                      <div className="col-sm-2">
                        <input
                          type="reset"
                          className="round-red-btn w-100 mt-3 clr"
                          value="RESET"
                          onClick={() => window.location.reload(false)}
                        />{" "}
                      </div>
                      <div className="col-sm-2">
                        <input
                          type="submit"
                          className="round-red-btn w-100 mt-3"
                          value="SUBMIT"
                        />{" "}
                      </div>
                    </div>
                  </div> */}
                </form>
              </div>
            </div>
          </div>
        </section>

        <Footer />
        <div className={`loader ${loading ? "in" : ""}`}>
          <div className="spinner-border main-spin"></div>
        </div>
        {/* <SeeAttachment /> */}
      </div>
    </>
  );
}

export default FileClaims;
